import {z} from 'zod';

import {translations} from 'presentation/translations-new';

const {bank, agency, account} = translations['pt-br'].privateFlow.profile.changeData.bankErrors;

export const BankDataSchema = z.object({
	bank: z.object(
		{
			code: z.string(),
			description: z.string(),
		},
		{required_error: bank},
	),
	agency: z.preprocess(
		val => String(val).replace(/\D/g, ''),
		z.string().min(1, agency).max(5, agency),
	),
	account: z.string().min(1, account).max(12, account),
	accountDigit: z.string().optional(),
	agencyDigit: z.string().optional(),
});

export type BankDataFormValues = z.infer<typeof BankDataSchema>;
